var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('billboard'),_vm._v(" "),_c('upcomingWidget',{attrs:{"list":2,"highlight":true}}),_vm._v(" "),_c('upcomingWidget',{attrs:{"list":2}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c4696e68","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sportsbook/fixtureHome.vue
// module id = o94N
// module chunks = 0